var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "#E5E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7142 27.3344C33.1633 27.3344 34.3379 28.509 34.3379 29.9581V30.6294C34.3379 31.6727 33.9651 32.6817 33.2867 33.4743C31.4557 35.6134 28.6706 36.669 25.0011 36.669C21.3309 36.669 18.5472 35.613 16.7199 33.473C16.0435 32.681 15.6719 31.6736 15.6719 30.632V29.9581C15.6719 28.509 16.8465 27.3344 18.2956 27.3344H31.7142ZM31.7142 29.0844H18.2956C17.813 29.0844 17.4219 29.4756 17.4219 29.9581V30.632C17.4219 31.257 17.6448 31.8614 18.0507 32.3366C19.5129 34.0489 21.8064 34.919 25.0011 34.919C28.1958 34.919 30.4913 34.0489 31.9571 32.3363C32.3643 31.8607 32.5879 31.2553 32.5879 30.6294V29.9581C32.5879 29.4756 32.1968 29.0844 31.7142 29.0844ZM25.0011 13.3398C28.2227 13.3398 30.8344 15.9515 30.8344 19.1732C30.8344 22.3948 28.2227 25.0065 25.0011 25.0065C21.7794 25.0065 19.1677 22.3948 19.1677 19.1732C19.1677 15.9515 21.7794 13.3398 25.0011 13.3398ZM25.0011 15.0898C22.7459 15.0898 20.9177 16.918 20.9177 19.1732C20.9177 21.4283 22.7459 23.2565 25.0011 23.2565C27.2563 23.2565 29.0844 21.4283 29.0844 19.1732C29.0844 16.918 27.2563 15.0898 25.0011 15.0898Z",
    fill: "#7D7D7D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackUser);
export default __webpack_public_path__ + "static/media/feedback_user.e7ad82cc47c4d83e134f0584e2d333b7.svg";
export { ForwardRef as ReactComponent };